import Ranking from "./Ranking";

const RankingContainer: React.FC = () => {
  return <Ranking />;
};

export default RankingContainer;
